module.exports = __webpack_public_path__ + "static/media/helping.66e1e087.svg";